import { createFileRoute } from '@tanstack/react-router';

import ClaimCancellationWithoutProofPage from '@/pages/claim-cancellation-without-proof.page';

export const Route = createFileRoute(
  '/_authenticated/contracts/$contractId/claim-cancellation-without-proof'
)({
  component: ClaimCancellationWithoutProofPage,
});
